import { fontMapping } from '@shared/utils/fonts/fontMap';
import { withWindow } from '@shared/utils/withWindow';
import { TextV2 } from '@withjoy/joykit';
import React, { FC, useEffect } from 'react';
import { styles } from '../../EventPreview.styles';
import { GuestSiteTypographyOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride';
import { display6ToEventTitleOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride.constants';
import { useFeatureValue } from '@shared/core/featureFlags';

type Props = {
  title?: string | null;
  font?: string;
  isExpanded?: boolean;
};

export const EventTitle: FC<Props> = ({ font, title = '', isExpanded = true }) => {
  const fontPackExperimentEnabled = useFeatureValue('fontPackExperiment').value === 'treatment';

  let mappedFont = font;
  if (font && mappedFont) {
    if (fontMapping[font]) {
      mappedFont = fontMapping[font];
    }
  }

  useEffect(() => {
    // Check if window is defined to ensure code runs only in the client side
    withWindow(() => {
      // Dynamically import the webfontloader library
      import('webfontloader').then(WebFont => {
        WebFont?.load({
          google: {
            families: [mappedFont || ''],
          },
        });
      });
    });
  }, [font, mappedFont]);
  return (
    <GuestSiteTypographyOverride
      override={display6ToEventTitleOverride}
      defaultFontFamily={font}
    >
      <TextV2
        {...(!fontPackExperimentEnabled && { fontFamily: font })}
        typographyVariant="display6"
        lineHeight="normal"
        __css={styles.eventName(isExpanded)}
      >
        {title}
      </TextV2>
    </GuestSiteTypographyOverride>
  );
};
